import { Alert } from "reactstrap";

const EmptyData = ({ title = "داده ای برای نمایش یافت نشد" }) => {
  return (
    <Alert color="primary mt-3" className="text-center">
      {title}
    </Alert>
  );
};

export default EmptyData;
